export default __webpack_public_path__ + "static/media/Logo.89acf19c.png";